<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-04-26 15:01:05
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-09 14:47:10
-->
<template>
<div class="xingshi">
    <Spin size="large" fix v-if="showLoading" class="totalLoad"></Spin>
    <h4 class="xingshi-title">点击格子区域可配置</h4>
    <table class="xingshi-table" id="tableBox">
        <tr class="xingshi-tr" v-for="(trItem,trIndex) in dataList" :key="trIndex">
            <td v-for="(tdItem,tdIndex) in trItem" :key="tdIndex" @click="clickTd(trIndex,tdIndex,tdItem)">
				<div class="" style="width:40px;height:40px;">
					<img :src="ossUrl+tdItem.thumb" alt="" class="hezi-thumb" v-if="tdItem.status == 0 && tdItem.thumb">
					<img :src="ossUrl+'/statics/home/images/empty_gezi.png'" alt="" class="hezi-thumb" v-if="tdItem.status != 0">
				</div>
			</td>
        </tr>
    </table>
    <hezi-item ref="heziItem" @changeHezi="onChangeHezi($event)"></hezi-item>
</div>
</template>

<script>
import heziItem from './hezi.vue'
export default {
    data() {
        return {
			showLoading: false,
            qiangId: null,
            dataList: [],
            initData: [],
			ossUrl: this.$publicData.ossUrl
        }
    },
    components: {
        heziItem
    },
    created() {
        this.qiangId = this.$route.query.id;
        this.getData();
    },
    methods: {
        /**
         * @name: 更新墙
         * @param {*} obj
         * @return {*}
         * @desc: 把图片塞进位置
         */		
        onChangeHezi(obj) {
            // console.log('onChangeHezi', obj)
			let item = this.dataList[obj.trIndex][obj.tdIndex];
			item.thumb = obj.img;
			item.status = obj.status;
			let initIndex = (obj.trIndex+1)*(obj.tdIndex) - 1;
			this.$set(this.initData,initIndex,item);
        },
        /**
         * @name: 点击td
         * @param {*} item
         * @param {*} trIndex
         * @param {*} tdIndex
         * @return {*}
         * @desc: 
         */
        clickTd(trIndex, tdIndex, item) {
            // console.log('item', item);
            let obj = {
                id: item.table_id,
				trIndex: trIndex,
				tdIndex: tdIndex,
                place: (trIndex + 1) + '行' + (tdIndex + 1) + '列'
            }
            this.$refs.heziItem.initFun(obj)
        },
        /**
         * @name: 获取数据
         * @return {*}
         * @desc: 含几行几列、空盒子数据
         */
        getData() {
            let params = {
                qiang_area_id: this.qiangId
            };
			this.showLoading = true;
            this.$api.baixingqiang.alltabledata(params).then(res => {
                if (res.code == 200) {
                    let info = res.result;					
                    this.initData = info.table;
                    this.zuheData(info.column)
                }else{
					this.showLoading = false;
				}
            })
        },
        /**
         * @name: 组合数据
         * @return {*}
         * @param colNum
         * @desc: 例如3行4列 列
         */
        zuheData(colNum) {
            let initData = this.initData;
            let dataList = [];
            for (let i = 0; i < initData.length; i += colNum) {
                dataList.push(initData.slice(i, i + colNum))
            };
            this.dataList = dataList;
			this.showLoading = false;
        }
    }
}
</script>